import React from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'mtn-footer': any;
    }
  }
}

const Footer: React.FC = () => {
  return (
    <mtn-footer
      mtnid="prod-mtnapp-39f46fcf-8dbd-4256-a49b-7f81f9107491"
      webcomponent="true"
      doormatTopLink={`https://eloket.antwerpen.be/nl/aanvraag/iets-fout-of-onduidelijk-gezien-op-de-website?referer=${window.location.href}`}
    />
  );
};

export default Footer;
